/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import { formatSeconds, getIcon, toMoney, zeroPad } from '../../../Components/Functions';
import Layout from '../../../Components/Layout';
import TimeSummary from '../../../Components/TimeSummary';
import { loggedUser } from '../../../Constants/menus';
import { routers } from '../../../Constants/routers';
import { to12hr } from '../../../Helpers/timeIntervals';
import { closePanel } from '../../../Redux/Panels/RightPanel/actions';
import Api from '../../../Server/Api';
import AppointmentRequests from './AppointmentRequests';
import { initDashboard } from './dbjs';

export const timeToShorts = (d) => {
  return d.split("-").map(e => { return e.substring(0,e.length === 7 ? 4 : 5) })
  .map((e) => to12hr(e)).join(" - ")
}

const api = new Api();

const stats = [
    {
        value: 0,
        label: "Patients",
        color: "is-info",
        icon: "users",
        link: routers.dashboard.patients
    },
    {
        value: 0,
        label: "Appointments",
        color: "is-purple",
        icon: "clock",
        link: routers.dashboard.appointments
    },
    {
        value: 0,
        label: "Earnings",
        color: "is-green",
        icon: "pie-chart",
        link: routers.dashboard.wallet,
        is_money: true
    },
    {
        value: 0,
        label: "Balance",
        color: "is-orange",
        icon: "shopping-cart",
        link: routers.account.billing,
        is_money: true
    },
]

const recentsAppointments = [
    {
        image: "",
        id: 19
    },
    {
        image: "",
        id: 19
    },
    {
        image: "",
        id: 19
    },
]


const barchart = {
    labels: [
        "2020-09-19T00:00:00.000Z",
        "2020-09-20T01:30:00.000Z",
        "2020-09-21T02:30:00.000Z",
        "2020-09-22T03:30:00.000Z",
        "2020-09-23T04:30:00.000Z",
        "2020-09-24T05:30:00.000Z",
        "2020-09-25T06:30:00.000Z"
    ],
    data: [31, 40, 28, 51, 42, 109, 100]
}

const Dashboard = () => {

    const datePicker = React.useRef(null);
    const [todaysAppointments, settodaysAppointments] = React.useState([]);
    const [todaysAppointmentsLoading, settodaysAppointmentsLoading] = React.useState(false);
    const [dashboard, setDashboard] = React.useState({});




    React.useEffect(() => {

        setTimeout(() => {
          if(bulmaCalendar){
            bulmaCalendar.attach(datePicker.current, {
                displayMode: 'inline',
                startDate: new Date(),
                lang: 'en'
            })
            // bulmaCalendar instance is available as element.bulmaCalendar
            datePicker.current.bulmaCalendar.on("select", function (datepicker) {
              const d = new Date(datepicker.data.value())
              settodaysAppointmentsLoading(true);
              api.get({
                endpoint: `/users/${loggedUser?.username}/appointments/`,
                data: {
                  statuses: ["ACCEPTED"],
                  date: `${d.getFullYear()}-${zeroPad(d.getMonth() + 1)}-${zeroPad(d.getDate())}`,
                  paystatus: 'SUCCESS'
                },
              }).then((res) => {
                if(res?.results?.length > 0) settodaysAppointments(res?.results)
                else settodaysAppointments([])
                settodaysAppointmentsLoading(false);
              })
            });

            document.getElementsByClassName("datetimepicker-footer-today")?.item(0)?.click()
          }

            api.get({ endpoint: `/users/${loggedUser?.username}/dashboard_summary/` })
            .then((res) => { if(res) {
              setDashboard(res);
              initDashboard({ bar: res?.review_summary?.chart, percent: res?.review_summary?.percent })
            } })

        }, 1500);
        // 
        

	}, []);

    return (
        <Layout sidePanel={true} title={"Dashboard"}>

<div className="personal-dashboard dashboard personal-dashboard-v3 ecommerce-dashboard ecommerce-dashboard-v1">
  <div className="columns">
    <div className="column is-8">
      <div className="columns is-multiline is-flex-tablet-p">
        <div className="column is-6">
          <div className="dashboard-card is-welcome is-elevated">
            <div className="welcome-title">
              <h3 className="dark-inverted text-capitalize">Hi {loggedUser?.title} {loggedUser?.first_name}</h3>
              <p>You have <b>{dashboard?.appointments?.week_count}</b> appointments to conduct during this week. Your current review
                is great.</p>
            </div>
            <div className="welcome-progress">
              <div id="welcome-gauge" className="gauge" />
              <div className="meta">
                <span>Your Reviews</span>
                <span className="dark-inverted">{dashboard?.review_summary?.description}</span>
              </div>
            </div>
            <div className="button-wrap">
              <a
                href={routers.dashboard.appointments}
              className="button h-button is-primary is-fullwidth is-big is-raised">View
                All Schedule</a>
            </div>
          </div>
        </div>
        <div className="column is-6">
          <div className="stats-wrapper">
            <div className="columns is-multiline is-flex-tablet-p">
                {stats.map((e) => {
                  const value = dashboard?.stats ? dashboard?.stats[e.label] : e.value
                    return (
                        <div className="column is-6" style={{ cursor: "pointer" }}
                        onClick={() => {
                            window.location = e.link
                        }}
                        >
                <div className="dashboard-card">
                  <div className="media-flex-center">
                    <div className={`h-icon ${e.color} is-rounded`} dangerouslySetInnerHTML={{ __html: getIcon(e.icon) }}>
                    </div>
                    <div className="flex-meta">
                      <span>{e.is_money ? toMoney(value) : value}</span>
                      <span>{e.label}</span>
                    </div>
                  </div>
                </div>
              </div>
                    )
                })}
              
            </div>
            <div className="people">
              <div className="left">
                <span className="dark-inverted">Total Patients</span>
                <span><a className="is-dark-primary">{dashboard?.appointments?.month_count} patients</a> this month</span>
              </div>
              <div className="right">
                <div className="avatar-stack">
                    {(dashboard?.appointments?.patients || []).slice(0,3).map((e) => {
                        return (
                            <div className="h-avatar">
                                <img 
                                    className="avatar" 
                                    src={e.image || require("../../../assets/images/placeholder.png").default}
                                    alt={(e.name || "").match(/\b(\w)/g).join('')}
                                    data-user-popover={e.id} 
                                    style={{
                                      backgroundColor: "#37514b",
                                      textAlign: "center"
                                    }}
                                    />
                            </div>
                        )
                    })}
                    {(dashboard?.appointments?.month_count - 3) > 0 && (
                      <div className="h-avatar">
                        <span className="avatar is-more">
                          <span className="inner">
                            <span>+{dashboard?.appointments?.month_count - 3}</span>
                          </span>
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="column is-6 h-hidden-mobile h-hidden-tablet-p">
        <img 
            src={loggedUser?.background_image || "https://images.pexels.com/photos/6457556/pexels-photo-6457556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"}
            style={{ borderRadius: 15, height: "auto" }} alt="" 
        />
        </div>
        <div className="column is-6">
          <div className="dashboard-card">
            <div id="interviews-chart" />
          </div>
        </div>
      </div>
    </div>
    <div className="column is-4">

    <div class="field">
          <div class="control">
              <input ref={datePicker} class="input" type="date"/>
          </div>
      </div>
      {todaysAppointmentsLoading && (
        <div className="dashboard-card is-interview" style={{ height: 275 }}>
          <div className="has-loader has-loader-active" style={{ height: 235 }}>
          <div className="h-loader-wrapper">
              <div className="loader is-small is-loading"></div>
          </div>
      </div>
        </div>
      )||(
        todaysAppointments?.length > 0 ? todaysAppointments.map((e) => {
          return (
            <a 
              href={routers.others.video_call(e?.meeting_id)} 
              className="dashboard-card is-interview">
                <div className="media-flex-center">
                <div className="h-avatar is-danger">
                    <img 
                        className="avatar" 
                        src={e?.patient_info?.image || require("../../../assets/images/placeholder.png").default}
                        data-user-popover={28} 
                        style={{ borderWidth: 2 }}
                        alt="" />
                </div>
                <div className="flex-meta">
                    <span>{e?.patient_info?.name}</span>
                    <span><i className="fas fa-calendar" />{" "}{e?.date_time} <i className="fas fa-clock" />{" "}{formatSeconds(e?.duration)}</span>
                    <div style={{ marginTop: 5 }}>
                    <TimeSummary {...e} />
                    </div>
                </div>
                <div className="flex-end" dangerouslySetInnerHTML={{ __html: getIcon("chevron-right") }}>
                </div>
                </div>
            </a>
          )
      }):(
        <div className="dashboard-card is-interview">
          <div style={{ width: '75%', margin: "auto" }}>
          <p style={{
            marginTop: '7rem',
            marginBottom: '6.5rem',
            textAlign: 'center',
            
          }}>No appointments on the selected date <b>{datePicker?.current?.value}</b> </p>
        </div>
        </div>
      )
      )}
      
    </div>
  </div>
    {dashboard?.appointments ? <AppointmentRequests /> : null}
</div>

        </Layout>
    )
}


const mapStateToProps = (state) => {
	return {  };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
